import { FunctionalComponent, h } from 'preact';

export const InfoIcon: FunctionalComponent<{ fill?: string; size?: number }> = (props) => {
	const { size = 16, fill = '#262626' } = props;

	return (
		<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
			      stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9 12V9" stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9 6H9.00667" stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
};
